{
    "smartTasks": {
        "tourLabel": "インテリジェントタスク",
        "learn": "Cephable を使用してテキストを生成、書き換え、翻訳する方法を学びます。",
        "generate": {
            "openTool": {
                "title": "テキスト生成ツールを開く",
                "description": "Cephable パネルで、「インテリジェント タスク」の横にあるニンジンをクリックし、「テキストの生成」を選択します。"
            },
            "enterPrompt": {
                "title": "プロンプトを入力",
                "description": "プロンプト ボックスに次のように入力します: インクで信頼できる 1 文の駄洒落を作成します。"
            },
            "clickGenerate": {
                "title": "生成をクリック",
                "description": "「生成」ボタンをクリックします。テキストがリアルタイムで表示されます。"
            },
            "focusApp": {
                "title": "アプリに焦点を当てる",
                "description": "生成されたテキストを表示したいアプリにフォーカスを合わせてください。「生成」をクリックすると、その場所にシームレスにテキストが生成されます。"
            }
        },
        "rewrite": {
            "welcome": {
                "title": "リライトへようこそ",
                "description": "強調表示または貼り付けたテキストを使用して、コンテンツをすばやく言い換えます。"
            },
            "highlightToggle": {
                "title": "強調表示されたテキストを使用する",
                "description": "「強調表示されたテキストを使用する」が選択されていることを確認します (デフォルト)。"
            },
            "highlightText": {
                "title": "書き換えるテキストを強調表示する",
                "description": "ハイライト: タコはそれぞれの腕を独立して制御できます。"
            },
            "enterInstructions": {
                "title": "書き換え指示を入力してください",
                "description": "タイプ: 古い英語スタイル。"
            },
            "clickGenerate": {
                "title": "生成をクリック",
                "description": "強調表示されたテキストは入力内容に基づいて書き換えられます。"
            },
            "pasteMode": {
                "title": "テキスト貼り付けを使用する",
                "description": "元のコードを貼り付けて、指示を書き換えます。「生成」をクリックします。「クリア」をクリックするとリセットされます。"
            },
            "openTool": {
                "title": "テキスト書き換えツールを開く",
                "description": "Cephable パネルで、「インテリジェント タスク」の横にあるニンジンをクリックし、「テキストの書き換え」を選択します。"
            },
            "focusApp": {
                "title": "アプリに焦点を当てる",
                "description": "書き換えたテキストを表示したいアプリにフォーカスを合わせてください。「生成」をクリックすると、その場所にシームレスにテキストが生成されます。"
            }
        },
        "translate": {
            "welcome": {
                "title": "翻訳へようこそ",
                "description": "強調表示または貼り付けられたテキストを別の言語に翻訳します。"
            },
            "highlightToggle": {
                "title": "強調表示されたテキストを使用する",
                "description": "「強調表示されたテキストを使用する」が選択されていることを確認します。"
            },
            "highlightText": {
                "title": "翻訳するテキストを強調表示する",
                "description": "ハイライト: タコはそれぞれの腕を独立して制御できます。"
            },
            "enterLanguage": {
                "title": "対象言語を入力してください",
                "description": "タイプ: ポルトガル語。"
            },
            "clickGenerate": {
                "title": "生成をクリック",
                "description": "翻訳はアプリのカーソル位置に入力されます。"
            },
            "pasteMode": {
                "title": "テキスト貼り付けを使用する",
                "description": "テキストと言語を貼り付けます。「生成」をクリックします。「クリア」をクリックするとリセットされます。"
            },
            "openTool": {
                "title": "テキスト翻訳ツールを開く",
                "description": "Cephable パネルで、「インテリジェント タスク」の横にあるニンジンをクリックし、「テキストの翻訳」を選択します。"
            }
        },
        "rowDescription": "インテリジェントタスクとは、CephableのAIがあなたに代わって実行できる様々なタスクです。これらのタスクはデバイス上のAIによって実行され、テキストの作成、要約、書き換え、翻訳など、さまざまな用途に使用できます。"
    },
    "overview": {
        "title": "概要",
        "description": "Cephableは、あなたのパーソナルAIです。素早いアクション、音声コマンド、コンテンツ生成、そしてツール全体のスマートな自動化を実現します。すぐに使える操作性。クラウド処理は不要。あなたの移動に合わせて生産性を向上します。"
    },
    "customControls": {
        "tourLabel": "常に利用可能なグローバルおよびデバイスコントロール",
        "rowDescription": "マイクがオンになっている場合、どのアプリを使用していても、グローバルコントロールとデバイスコントロールは常に利用できます。これらのコントロールを使えば、新しいアプリコントロールを作成することなくデバイスを操作できます。コントロールやアプリの切り替え、テキストの生成、マイクの一時停止など、便利なコマンドが含まれています。"
    },
    "profile": {
        "tourLabel": "アプリコントロール",
        "learn": "Cephable でアプリのコントロールと設定を設定する方法を学びます。",
        "rowDescription": "アプリコントロールは、様々な操作を行うために使用できる一連のコントロールで構成されています。プレゼンテーションの次のスライドに移動するには「次のスライド」と発声したいですか？頭の動きでカーソルを動かし、音声コントロールで編集ショートカットを操作したいですか？アプリコントロールを使えば、これらが可能です。コントロール行には、現在のアプリで使用できるすべてのコントロールが表示されます。",
        "check": {
            "title": "利用可能なコントロールを確認します。",
            "description": "アプリコントロールは、使用しているアプリごとにご利用いただけます。ここでは、現在使用しているアプリで利用可能なコントロールを確認できます。別のコマンドを試して、どのように動作するかを確認してください。ただし、操作したいアプリにフォーカスを当てていることを確認してください。"
        }
    },
    "dictation": {
        "tourLabel": "ディクテーション",
        "learn": "ディクテーション モードを使用して、ハンズフリーで音声をテキストに変換する方法を学びます。",
        "welcome": {
            "title": "ディクテーション",
            "description": "ディクテーションを使えば、自然な話し方で、話しながら入力できます。まるで、あなたの話す言葉をすべて入力してくれるパーソナルアシスタントがいるかのようです。"
        },
        "microphone": {
            "title": "マイクをオンにする",
            "description": "まず、マイクをオンにします。Cephableパネルのマイク切り替えボタンをクリックします。"
        },
        "activate": {
            "title": "ディクテーションモードを開始",
            "description": "音声はコマンドモードで起動します。ディクテーションを開始するには、「ディクテーションを開始」と言うか、ディクテーションボタンをクリックしてください。それでは、ディクテーションモードをオンにしましょう。"
        },
        "focus": {
            "title": "テキストフィールドまたはドキュメントにフォーカスする",
            "description": "ディクテーションは、テキストフィールドまたはドキュメントにフォーカスを当てると最も効果的に機能します。ディクテーションしたいテキストフィールドまたはドキュメントをクリックします。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。「こんにちは。ディクテーションモードのテストです」のように言ってみてください。"
        },
        "pauseResume": {
            "title": "ディクテーションの一時停止",
            "description": "ディクテーションを停止せずに休憩したい場合は、「ディクテーションを一時停止」と発声してください。「ディクテーションを開始」と発声すればいつでも再開できます。この機能は、常時オンのグローバルコントロールとデバイスコントロールでさらにカスタマイズできます。"
        },
        "stop": {
            "title": "ディクテーションをやめる",
            "description": "アプリのコントロールに戻りたいですか？「ディクテーションを停止」と言うだけです。これでディクテーションモードが停止し、コマンドモードに戻ります。「ディクテーションを開始」と言えばいつでも再開できます。"
        },
        "complete": {
            "description": "これで完了です！音声入力、一時停止、再開、そして音声入力モードとコマンドモードの切り替えができるようになりました。音声入力はハンズフリー入力を可能にする強力なツールです。メールや文書の作成など、音声入力が必要なあらゆる作業にお使いいただけます。"
        }
    },
    "camera": {
        "tourLabel": "カメラコントロール",
        "rowDescription": "カメラコントロールを使用すると、顔や体を使ってデバイスを操作できます。さまざまな表情や頭の動きを使ってデバイスを操作できます。マイクをオンにすると、音声コマンドでカメラの起動と停止、カメラの切り替えができます。",
        "learn": "カメラ コントロールを使用して、ハンズフリーでデバイスを操作および操作する方法を学びます。",
        "welcome": {
            "title": "カメラコントロール",
            "description": "カメラコントロールを使えば、顔や体を使ってデバイスを操作できます。表情や頭の動き、音声コマンドを使って、ハンズフリーでデバイスを操作できます。"
        },
        "start": {
            "title": "カメラコントロールを開始",
            "description": "音声を使用している場合にカメラ コントロールを開始するには、「カメラ コントロールを開始」と言うか、[カメラ コントロール] ボタンをクリックします。"
        }
    },
    "microphone": {
        "tourLabel": "音声コントロール",
        "learn": "音声を使用して任意のアプリを制御し、ディクテーションを使用して話したことを入力する方法を学びます。",
        "description": "Cephable Voice Controlsを使えば、音声でデバイスを操作できます。ドキュメントを保存したいですか？「保存」と言うだけです。音楽を一時停止したいですか？「一時停止」と言うだけです。音声入力機能を使えば、話した内容を音声入力することもできます。",
        "rowDescription": "マイクがオフになっていると、音声コマンドは全く認識されません。しかし、オンにすると、一時停止や開始などの操作をグローバルコマンドで操作できるようになります。さあ、オンにしてみましょう。",
        "start": {
            "title": "音声コントロールを開始",
            "description": "音声コントロールを使い始めるには、セファブルパネルのマイク切り替えボタンをクリックします。マイクがオンになり、コマンドの聞き取りが開始されます。"
        },
        "tryOpen": {
            "title": "「Spotify を開く」または「Word を開く」と言ってみてください",
            "description": "`Open` は、指定したアプリを開き、フォーカスをそのアプリに送るグローバルコマンドです。自動コントロール切り替えが有効になっている場合は、使用中のアプリに最適なアプリコントロールに切り替えます。"
        },
        "finishedCommands": {
            "title": "素晴らしい！音声コントロールの基本を学習しました。",
            "description": "サポートページからいつでもツアーを再開できます。次のステップはディクテーションについて学ぶことです。サポートページからツアーを開始できます。"
        }
    },
    "publicProfiles": {
        "tourLabel": "アプリコントロールをカスタマイズする"
    },
    "tour": {
        "title": "Cephableへようこそ",
        "description": "Cephableは、音声、カメラ、その他の入力を使ってコンピューターを操作できる強力なツールです。このツアーでは、主要な機能と効果的な使い方をご紹介します。",
        "startTour": "ツアーを開始",
        "finishTour": "ツアー終了",
        "statusDialog": "詳細についてはパネルをご確認ください。",
        "step": "{{step}} / {{total}} ステップ",
        "next": "次",
        "previous": "前の",
        "endTour": "ツアー終了",
        "nextTourLabel": "次へ: {{nextStepTitle}}",
        "skipTour": "ツアーをスキップ",
        "steps": {
            "welcome": {
                "title": "Cephableへようこそ",
                "description": "このツアーでは、Cephableの主な機能をご紹介します。さあ、始めましょう！"
            },
            "inputs": {
                "title": "入力の概要",
                "description": "Cephableは、音声コマンド、カメラ操作など、さまざまな入力方法をサポートしています。これらの入力は設定でカスタマイズできます。"
            },
            "appControls": {
                "title": "アプリコントロール",
                "description": "アプリコントロールを作成して、入力をアプリケーション内の特定のアクションにマッピングします。これにより、ジェスチャーや音声コマンドなどでアプリを操作できるようになります。"
            },
            "settings": {
                "title": "設定",
                "description": "設定にアクセスして、入力方法、アプリのコントロール、その他の設定を変更できます。アカウントと言語設定もここで管理できます。"
            },
            "intelligentTasks": {
                "title": "インテリジェントタスク",
                "description": "AI を活用した機能を使用して、インテリジェント タスクでテキストの生成、コンテンツの要約、テキストの書き換え、言語の翻訳などを行うことができます。"
            },
            "cameraControls": {
                "title": "カメラコントロール",
                "description": "カメラ コントロールを有効にすると、顔の表情や頭の動きを入力方法としてコンピューターをコントロールできます。"
            },
            "voiceControls": {
                "title": "音声コントロール",
                "description": "音声コマンドを使ってハンズフリーでコンピューターを操作できます。音声でテキストを入力したり、コマンドを発行したり、アプリケーションを操作したりできます。"
            }
        }
    },
    "onboarding": {
        "demoPlaceholder": "これはデモ用のプレースホルダテキストです。上記のプロンプトを使用して、このテキストのスタイルを制御できます。",
        "exit": "セットアップを終了",
        "overview": "概要",
        "learn": "Cephable の機能とその使用方法について学びます。",
        "start": "まだ始まったばかりのようですね。これから役立つヒントをいくつかご紹介します。",
        "startTour": "始める",
        "dashboard": {
            "title": "Cephableダッシュボード",
            "description": "Cephableダッシュボードは、デバイス、アプリのコントロール、設定を管理するための中心的なハブです。ここから、エクスペリエンスをカスタマイズしたり、アクティブなコマンドを確認したり、Cephableのすべての機能にアクセスしたりできます。"
        },
        "step1": {
            "title": "Cephableへようこそ",
            "description": "Cephableは、あなたのパーソナルAIです。素早いアクション、音声コマンド、コンテンツ生成、そしてツール全体のスマートな自動化を実現します。すぐに使える操作性。クラウド処理は不要。あなたの移動に合わせて生産性を向上します。",
            "inputs": "入力とは何ですか?",
            "inputDescription": "入力コントロールとは、デバイスを操作するための方法であり、従来のマウスとキーボードを超えてコンピューターの機能を拡張します。これには、音声コマンド、頭の動き、表情、その他の周辺機器などが含まれます。",
            "profiles": "アプリコントロールとは何ですか?",
            "profileDescription": "アプリコントロールを使用すると、入力と出力のコントロールを組み合わせることで、独自の方法でコンピューターに接続し、通信することができます。アプリコントロールを使用すると、頭を傾けるだけでファイルを保存したり、笑顔でメールの「送信」をクリックしたりするなど、Cephableにタスクを実行させることができます。",
            "action": "入力コントロールを調べる",
            "secondaryAction": "アプリコントロールへスキップ",
            "secondaryActionDescription": "入力コントロールについてすでにご存知ですか?"
        },
        "finish": {
            "title": "セットアップ完了",
            "description": "Cephableアプリコントロールの最初の使用に成功しました！これで、デバイスでこれらの機能やその他の機能を利用できるようになります。Cephableダッシュボードでアプリコントロールの設定を必要に応じてカスタマイズできます。",
            "continueToApp": "Cephableダッシュボードに進む",
            "keepExploring": "探検を続ける"
        },
        "useCaseSlider": {
            "context": "使用したい",
            "control": "制御する"
        }
    },
    "support": {
        "tourLabel": "さらに詳しく知りたいですか?",
        "description": "Cephable の使用方法に関する詳細情報（その他のツアー、ステップバイステップ ガイド、チュートリアル、ビデオなど）については、サポート ハブをご覧ください。",
        "cta": "他のツアーを見る"
    },
    "featureFlag": {
        "title": "アップグレードの時期",
        "description": "ご利用になりたい機能には別のライセンスが必要です。この機能やその他の機能をご利用いただくには、アップグレードしてください。"
    },
    "replyToSocialMedia": {
        "tourLabel": "ディクテーションでソーシャルメディアへの返信を高速化",
        "learn": "ディクテーションを使用してハンズフリーでソーシャル メディアの投稿に返信する方法を学びます。",
        "navigateTo": {
            "title": "ソーシャルメディアの投稿に移動する",
            "description": "ウェブブラウザを開き、LinkedInやFacebookなどのソーシャルメディアプラットフォームにアクセスします。返信したい投稿を見つけます。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。「おめでとうございます！楽しみにしています」のように言ってみてください。カーソルがテキストフィールドまたはコメントボックスにフォーカスされていることを確認してください。"
        },
        "complete": {
            "description": "これで完了です！音声入力、一時停止、再開、音声入力モードとコマンドモードの切り替えなどを使って、ハンズフリーでソーシャルメディアの投稿に返信できます。音声入力はハンズフリー入力のための強力なツールです。メールや文書の作成など、音声入力が必要なあらゆる作業にお使いいただけます。"
        }
    },
    "hotkeys": {
        "tourLabel": "クイックアクションボタン",
        "learn": "クイック アクション ボタンを設定して、複数のアクションを 1 つのボタンにマッピングする方法を学びます。",
        "rowDescription": "クイックアクションボタンを使用すると、1つのコマンドで複数のアクションを実行できます。例えば、お気に入りの音楽アプリを起動して特定のプレイリストの再生を開始するボタンを作成できます。",
        "check": {
            "title": "利用可能なクイックアクションを確認します。",
            "description": "クイックアクションボタンは、使用するアプリごとにご利用いただけます。ここでは、現在使用中のアプリで利用できるボタンを確認できます。別のコマンドを試して、どのように動作するかを確認してください。ただし、操作したいアプリにフォーカスを当てていることを確認してください。"
        }
    },
    "controllingBackgroundMusic": {
        "tourLabel": "作業の流れを中断せずにBGMを管理する",
        "learn": "現在のタスクに集中しながら、音声コントロールとクイックアクションを使用してハンズフリーで音楽を制御する方法を学びます。",
        "tryOpen": {
            "title": "「Spotifyを開く」または「Apple Musicを開く」と言ってみてください"
        },
        "play": {
            "title": "音楽の再生を開始するには、「再生」と言ってみてください",
            "description": "マイクがオンになっていることを確認して、「再生」と発声してください。選択した音楽アプリで音楽の再生が始まります。他のメディアアプリでも同様に機能します。"
        },
        "newPlaylist": {
            "title": "新しいプレイリストを作成する",
            "description": "マイクがオンになっていることを確認し、「新しいプレイリスト」と発声してください。選択した音楽アプリで新しいプレイリストの作成プロセスが開始されます。"
        },
        "finishedCommands": {
            "title": "よくできました！ハンズフリーで音楽をコントロールする方法を学びました。",
            "description": "お気に入りの音楽アプリで、音声コマンドとクイックアクションを使って再生、一時停止、曲のスキップ、音量調整を行う方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、さらにスムーズな音楽操作を実現しましょう。"
        }
    },
    "editingVideos": {
        "tourLabel": "動画編集の面倒なクリックではなく、ストーリーに集中しましょう",
        "learn": "音声コントロールとクイックアクションを使用してビデオをより速く編集し、編集中にどのボタンをクリックするかを覚えておくという認知負荷を取り除く方法を学習します。",
        "tryOpen": {
            "title": "「iMovieを開く」または「DaVinci Resolveを開く」と言ってみてください。"
        },
        "play": {
            "title": "「再生」と言ってビデオを再生してみましょう",
            "description": "マイクがオンになっていることを確認して、「再生」と発声してください。選択した動画編集アプリで動画の再生が始まります。"
        },
        "stop": {
            "title": "ビデオの再生を停止",
            "description": "マイクがオンになっていることを確認し、「停止」と言ってください。選択した動画編集アプリで動画の再生が停止します。"
        },
        "finishedCommands": {
            "title": "よくできました！ハンズフリーでビデオ編集を操作する方法を学びました。",
            "description": "お気に入りの動画編集アプリで、音声コマンドとクイックアクションを使って再生、一時停止、トラックスキップ、音量調整を行う方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、さらにスムーズな動画操作を実現しましょう。"
        }
    },
    "vibeCoding": {
        "tourLabel": "ディクテーションでアイデア創出、プロトタイプ作成、反復作業をスピードアップ",
        "learn": "ディクテーションと AI を活用したテキスト生成を使用して、コードの実行、プロトタイプの作成、アイデアの反復処理を実行する方法を学びます。",
        "navigateTo": {
            "title": "Vibeコードエディターに移動する",
            "description": "ウェブブラウザを開き、Vibeコードエディタにアクセスしてください。例としては、Vercel V0、VS CodeのGitHub Copilot、Base 44、Lovableなどがあります。"
        },
        "focus": {
            "title": "新しいチャットをクリックするか、テキストボックスにフォーカスを当てます",
            "description": "ディクテーションは、テキストフィールドまたはドキュメントにフォーカスを当てると最も効果的に機能します。ディクテーションしたいコメントボックスまたは返信スレッドをクリックして、読み上げを開始してください。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。技術的な要件やコードの動作を話してみてください。カーソルがテキストフィールドまたはコメントボックスにフォーカスされていることを確認してください。"
        },
        "rewriteIntro": {
            "title": "命令を使ってコードを書き換える",
            "description": "また、Rewriteなどのインテリジェントタスクを使用して、既存のコードをその場で変更することもできます。このタスクはデバイス上のAIによって実行されるため、インターネット接続なしでもデバイスから実行できます。"
        },
        "highlightText": {
            "title": "書き換えるテキストを強調表示する",
            "description": "書き換えたいコードを強調表示します。"
        },
        "enterInstructions": {
            "title": "書き換え指示を入力してください",
            "description": "コーディングの書き換え指示を入力してください。プログラミング言語、スタイル、または必要な変更点などを指定してください。"
        },
        "complete": {
            "description": "これで完了です！これで、コード上で音声入力、一時停止、再開、反復処理ができるようになりました。音声入力やインテリジェントタスク、その他のワークフロー最適化機能を使って、さらに多くのユースケースを探索してみてください。"
        }
    },
    "documentCode": {
        "tourLabel": "デバイス上の AI テキスト生成による高速で安全なコードドキュメント",
        "learn": "同じアプリ内でデータの安全性を保ちながら、AI を活用した書き換えを使用してコードを文書化する方法を学びます。",
        "rewriteIntro": {
            "title": "コードドキュメントの作成",
            "description": "Cephable Intelligent Rewrite を使用すると、別のドキュメントまたはアプリにコードドキュメントを作成できます。Rewrite は、オフライン生成と翻訳を含むデバイス内 AI タスクの一部です。"
        },
        "focusApp": {
            "title": "コードに集中する",
            "description": "IDE を開き、ドキュメント化するコードに焦点を当てます。"
        },
        "newFile": {
            "title": "ドキュメントファイルを作成する",
            "description": "IDE で新しいファイルを作成するか、ドキュメントを表示する別のアプリを開きます。"
        },
        "highlightText": {
            "title": "ハイライトコード",
            "description": "文書化するコードを強調表示してコピーします。"
        },
        "pasteMode": {
            "title": "テキスト貼り付けタブをクリック",
            "description": "貼り付けモードを使用して元のコードを貼り付け、新しいファイルにドキュメントを書き込みます。"
        },
        "pasteInput": {
            "title": "ドキュメントにコードを貼り付ける",
            "description": "文書化するコードを入力ボックスに貼り付けます。"
        },
        "enterInstructions": {
            "title": "書式、スタイル、コンテンツの指示を入力します",
            "description": "コーディングドキュメントの指示を入力します。ファイルの種類（マークダウンなど）、スタイル、または必要な特定のコンテンツを指定します。"
        },
        "complete": {
            "description": "インテリジェントタスクを使って迅速かつ安全にコードドキュメントを作成する方法を学習しました。Rewriteやその他の機能を使って、ワークフローを最適化するユースケースをさらに探ってみましょう。"
        }
    },
    "generateCode": {
        "tourLabel": "デバイス上の AI テキスト生成による高速で安全なコード生成",
        "learn": "AI を活用した生成を使用して、アプリ間を移動しながらデータを安全に保ちながらコード スニペットを作成する方法を学びます。",
        "rewriteIntro": {
            "title": "コードスニペットを書く",
            "description": "Cephable Intelligent Rewrite を使用すると、別のアプリケーションから要件を取得しながら、IDE でコードスニペットを作成できます。Rewrite は、オフライン生成や翻訳を含むオンデバイス AI タスクの一部です。"
        },
        "focusApp": {
            "title": "チケットの内容に注目",
            "description": "要件を指定するチケットを開き、コードを生成するコンテンツに焦点を当てます。"
        },
        "newFile": {
            "title": "コードスニペットファイルを作成する",
            "description": "IDE で新しいファイルを作成します。"
        },
        "highlightText": {
            "title": "ハイライトチケットの内容",
            "description": "コードを生成するコンテンツを強調表示してコピーします。"
        },
        "pasteMode": {
            "title": "テキスト貼り付けタブをクリック",
            "description": "貼り付けモードを使用して、元のチケット要件を貼り付け、コード スニペットを記述します。"
        },
        "pasteInput": {
            "title": "要件を貼り付けてコードを生成する",
            "description": "コード生成に使用する要件を入力ボックスに貼り付けます。"
        },
        "enterInstructions": {
            "title": "プログラミング言語とスタイルの指示を入力してください",
            "description": "プログラミング言語とスタイルの指示を入力してください。プログラミング言語（例：C#）、スタイル、または具体的なコーディング指示を指定します。"
        },
        "translateIntro": {
            "title": "コードスニペットを翻訳する",
            "description": "Cephable Intelligent Translate を使用すると、IDE 内でコードスニペットをあるプログラミング言語から別のプログラミング言語へ直接変換できます。Translate は、オフライン生成と書き換えを含むオンデバイス AI タスクの一部です。"
        },
        "copyGeneratedCode": {
            "title": "生成されたコードをコピーする",
            "description": "前の手順を使用してコードを生成した後、生成されたコード スニペットを強調表示してコピーします。"
        },
        "translatePasteMode": {
            "title": "テキスト貼り付けタブをクリック",
            "description": "貼り付けモードを使用して元のコードを貼り付け、別のプログラミング言語に変換します。"
        },
        "enterProgrammingLanguage": {
            "title": "ターゲットプログラミング言語を入力してください",
            "description": "コードを変換するプログラミング言語 (例: Python) を入力します。"
        },
        "pasteCode": {
            "title": "生成されたコードをIDEに貼り付けます",
            "description": "IDE に移動し、コピーしたコード スニペットを先ほど作成した新しいファイルに貼り付けます。"
        },
        "complete": {
            "description": "インテリジェントタスクを使って、迅速かつ安全にコード生成と翻訳を行う方法を学習しました。生成と翻訳やその他の機能を使って、ワークフローを最適化するユースケースをさらに探ってみましょう。"
        }
    },
    "requirementDocsFromMeeting": {
        "tourLabel": "数分でメモから製品要件ドキュメントを作成",
        "learn": "AI インテリジェント タスクを使用して、データを安全に保ちながら会議メモから構造化された製品要件ドキュメントを作成する方法を学びます。",
        "rewriteIntro": {
            "title": "製品要件ドキュメントの作成",
            "description": "Cephable Intelligent Rewrite を使用すると、会議メモから構造化された製品要件ドキュメントを作成できます。Rewrite は、オフライン生成と翻訳を含むオンデバイス AI タスクの一部です。"
        },
        "focusNotes": {
            "title": "会議メモを開く",
            "description": "会議のメモ、議事録、またはその他の会議関連のテキスト コンテンツを開きます。"
        },
        "highlight": {
            "title": "会議メモのハイライト",
            "description": "製品要件ドキュメントの作成に使用する会議メモを強調表示します。"
        },
        "enterInstructions": {
            "title": "ドキュメント構造とコンテンツの指示を入力する",
            "description": "製品要件ドキュメントの指示を入力してください。構造、スタイル、または必要な特定のコンテンツを指定してください。"
        },
        "complete": {
            "description": "インテリジェントタスクを使用して、迅速かつ安全に製品要件ドキュメントを作成する方法を学習しました。Rewriteやその他の機能を使って、ワークフローを最適化するユースケースをさらに探ってみましょう。"
        }
    },
    "headMouseMovement": {
        "tourLabel": "ヘッドマウスを使ったハンズフリーゲーミングセットアップ",
        "learn": "頭の動きを使ってマウス カーソルを制御し、正確なナビゲーションとクリックを行う方法を学びます。",
        "deviceSettings": {
            "title": "デバイス設定を開く",
            "description": "ヘッドマウスの動きを有効にするには、[デバイス設定] ボタンをクリックします。"
        },
        "cameraSettings": {
            "title": "カメラ設定を開く",
            "description": "デバイス設定で、カメラ設定をクリックしてカメラコントロールにアクセスします。"
        },
        "headMouseSection": {
            "title": "マウス操作のための頭の動き",
            "description": "これをオンにすると、トリガー コントロールの代わりに、ヘッド ムーブメント コントロールの一部がマウスの移動に使用されます。"
        },
        "steadyGlide": {
            "title": "安定した滑空モード",
            "description": "ステディグライドモードをオンにします。頭を特定のポイントを超えて動かすと、カーソルがその方向に一定の速度で連続的に移動します。"
        },
        "customization": {
            "title": "ヘッドマウス設定をカスタマイズする",
            "description": "ヘッドマウスの設定を好みに合わせてカスタマイズできます。速度、感度、その他の設定を調整して、最適な操作性を実現しましょう。"
        },
        "save": {
            "title": "ヘッドマウス設定を保存",
            "description": "カスタマイズしたヘッドマウスの設定を忘れずに保存してください。"
        },
        "transition": {
            "title": "セファブルパネルへの移行",
            "description": "それでは、Cephable パネルに移動して、マウスの頭の動きを試してみましょう。"
        },
        "playGames": {
            "title": "ヘッドマウスでゲームをプレイ",
            "description": "ゲーム中に頭の動きでマウスカーソルを操作できるようになりました。ぜひ試してみて、その効果を実感してください！"
        }
    },
    "clinicalNoteTaking": {
        "tourLabel": "臨床医のためのHIPAA準拠のディクテーションとフォーマット",
        "learn": "音声コマンド、スマートディクテーション、AI フォーマットを使用して臨床メモを取る方法を学びます。",
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。「患者様は45歳の男性で、高血圧の既往歴があります。前回処方された薬が期待通りの効果を示さず、アレルギー反応を起こしました。代替薬を検討する必要がありますが、ジェネリック医薬品の処方箋を希望されています。」のように言ってみてください。"
        },
        "rewriteIntro": {
            "title": "メモのフォーマット",
            "description": "Cephable Intelligent Rewrite を使えば、メモをSOAP形式でフォーマットできます。すべてデバイス上で実行されるため、データのプライバシーとセキュリティは維持され、HIPAAに準拠します。"
        },
        "copyText": {
            "title": "メモをコピーする",
            "description": "メモをハイライトした後、テキストをコピーして書式設定の準備をします。"
        },
        "pasteMode": {
            "title": "テキスト貼り付けタブをクリック",
            "description": "貼り付けモードを使用して元のメモを貼り付け、SOAP スタイルでフォーマットします。"
        },
        "pasteInput": {
            "title": "メモをフォーマットに貼り付ける",
            "description": "フォーマットしたいメモを入力ボックスに貼り付けます。"
        },
        "enterInstructions": {
            "title": "書式設定の指示を入力してください",
            "description": "クリニック/EHRシステムで遵守する必要があるフォーマット指示を記述できます。（例：見出し、箇条書き、簡潔な言葉遣いを含むSOAPスタイルでフォーマットする）"
        },
        "navigateToEHR": {
            "title": "EHRシステムへ移動",
            "description": "EHR システムを開き、フォーマットされたメモを入力するセクションに移動します。"
        },
        "focusTextField": {
            "title": "テキストフィールドにフォーカス",
            "description": "フォーマットされたメモを貼り付けるテキスト フィールドをクリックします。"
        },
        "complete": {
            "description": "音声コマンドとスマートディクテーションを使って臨床ノートを作成し、インテリジェントリライトを使ってSOAPスタイルでフォーマットする方法を学びました。ディクテーションとリライト、あるいはワークフローを最適化するその他の機能を使ったユースケースをさらに探ってみましょう。"
        },
        "focus": {
            "title": "ドキュメントに焦点を当てる",
            "description": "ディクテーションは、文書に集中しているときに最も効果的に機能します。セッションの合間に臨床メモを取りたい文書を開いてください。"
        }
    },
    "webBrowsing": {
        "tourLabel": "音声を使って旅行を計画したり、オンラインショッピングをしたり、Webを閲覧したりできます",
        "learn": "ハンズフリーで Web を閲覧しながら、音声コマンドを使用してナビゲート、スクロール、フォームへの入力を行う方法を学びます。",
        "tryOpen": {
            "title": "「Chrome を開く」または「Edge を開く」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「Chromeを開く」または「Edgeを開く」と発声してください。選択したウェブブラウザが開きます。自動コントロール切り替えが有効になっている場合は、使用中のアプリに最適なアプリコントロールに切り替わります。"
        },
        "search": {
            "title": "検索中",
            "description": "「検索」または「検索」と発声してみてください。ブラウザの検索バーにフォーカスが当たります。"
        },
        "quickType": {
            "title": "クイックタイピング",
            "description": "クイック入力を使えば、ディクテーションモードを使わずに音声入力できます。「今日の天気を入力」と発声してみてください。検索バーに検索クエリが入力されます。"
        },
        "enter": {
            "title": "Enterキーを押します",
            "description": "「Enter」と発声してみてください。入力した検索クエリが実行されます。"
        },
        "scrollDown": {
            "title": "下にスクロール",
            "description": "「下にスクロール」と言ってみてください。ウェブページが下にスクロールします。"
        },
        "scrollUp": {
            "title": "上へスクロール",
            "description": "「上にスクロール」と言ってみてください。ウェブページが上にスクロールします。"
        },
        "newTab": {
            "title": "新しいタブを開く",
            "description": "「新しいタブ」と言ってみてください。ブラウザで新しいタブが開きます。"
        },
        "formsCustomization": {
            "title": "フォーム入力のカスタマイズ",
            "description": "このアプリのコントロールをカスタマイズして、フォーム入力を簡単に行うことができます。例えば、名、姓、メールアドレスなどです。その後、クイックアクションや音声コマンドを使って、フォームへの入力をさらに素早く行うことができます。"
        },
        "complete": {
            "title": "素晴らしい仕事です！",
            "description": "音声コマンドとクイックアクションを使って、ウェブ閲覧中にナビゲート、検索、スクロール、フォームへの入力を行う方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、さらにスムーズなウェブ閲覧を実現しましょう。"
        }
    },
    "spreadsheetReviews": {
        "tourLabel": "音声コントロールでスプレッドシートの作業を高速化",
        "learn": "音声コマンドとクイック アクションを使用して、大きなスプレッドシートをすばやく確認および編集する方法を学びます。",
        "tryOpen": {
            "title": "「Excel を開く」または「Google スプレッドシートを開く」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「Excelを開く」または「Googleスプレッドシートを開く」と発声してください。選択したスプレッドシートアプリが開きます。自動コントロール切り替えが有効になっている場合は、使用中のアプリに最適なアプリコントロールに切り替わります。"
        },
        "selectRow": {
            "title": "行を選択",
            "description": "セルをクリックします。次に、「行を選択」と発声してみましょう。これにより、フォーカスされたセルの行全体が選択されます。"
        },
        "delete": {
            "title": "行の内容を削除する",
            "description": "「削除」と言ってみてください。選択した行の内容が削除されます。"
        },
        "note": {
            "title": "セルにメモを追加する",
            "description": "セルをクリックします。次に、「メモを追加」と発声してみましょう。これにより、フォーカスされたセルにメモを追加できます。"
        },
        "addNote": {
            "title": "メモを入力してください",
            "description": "「これらの数字は一致しません」と言ってみてください。すると、セルにメモが入力されます。"
        },
        "currentDate": {
            "title": "現在の日付を入力",
            "description": "セルをクリックします。次に「現在の日付」と発声してみましょう。すると、フォーカスされたセルに現在の日付が入力されます。"
        },
        "copy": {
            "title": "セルをコピーする",
            "description": "先ほど現在の日付を追加したセルをクリックします。次に「コピー」と発声してみましょう。これで現在の日付がコピーされます。"
        },
        "selectColumn": {
            "title": "列を選択",
            "description": "「列」と言ってみてください。フォーカスされたセルの列全体が選択されます。"
        },
        "paste": {
            "title": "現在の日付を貼り付け",
            "description": "「貼り付け」と言ってみてください。選択した列に現在の日付が貼り付けられます。"
        },
        "quickActions": {
            "title": "クイックアクションを使用する",
            "description": "クイックアクションボタンを使えば、これらの操作の多くに加え、さらに多くの操作を実行できます。これらのボタンをワークフローに合わせてカスタマイズすることで、スプレッドシートの確認と編集をさらに迅速に行うことができます。"
        },
        "complete": {
            "description": "音声コマンドとクイックアクションを使って、大きなスプレッドシートを素早く確認・編集する方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、スプレッドシートをより速く管理してみましょう。"
        }
    },
    "socialMediaWriting": {
        "tourLabel": "音声とデバイス上の AI を活用して、ソーシャル メディア コンテンツを作成、反復、投稿する",
        "learn": "完全にプライベートでデバイス上で実行されるインテリジェントな生成と書き換え機能を使用して、コンテンツを作成し、反復処理する方法を学びます。",
        "onDeviceIntro": {
            "title": "あなたの研究はプライバシーとセキュリティを保ちます",
            "description": "Cephableのインテリジェントタスクはデバイス上のAIを搭載しているため、データのプライバシーとセキュリティは確保されます。クラウド処理を必要とせず、テキストの作成、書き換え、翻訳が可能です。また、クロスアプリケーションコンテキストを活用し、お気に入りのアプリ内で直接アイデアを反復処理することも可能です。"
        },
        "enterPrompt": {
            "title": "アイデア出しを始める",
            "description": "入力ボックスに、スキャフォールディングまたは生成したいコンテンツのプロンプトを入力します。例えば、「エージェント型AIのリスク、ギャップとなる点、そしてイノベーションを前進させる方法を挙げてください」と入力できます。"
        },
        "customizeSettings": {
            "title": "生成設定をカスタマイズする",
            "description": "好みに合わせて生成設定をカスタマイズできます。トーンやブランドボイスなどを反映したシステムプロンプトで調整できます。"
        },
        "rewriteIntro": {
            "title": "コンテンツの反復",
            "description": "Cephable Intelligent Rewrite を使用すると、お気に入りのアプリ内で直接コンテンツを反復処理できます。すべてデバイス上で実行されるため、データのプライバシーとセキュリティは確保されます。"
        },
        "highlightText": {
            "title": "書き換えるテキストを強調表示する",
            "description": "生成されたコンテンツから、さらに反復するリストされたリスクの 1 つを強調表示します。"
        },
        "enterInstructions": {
            "title": "書き換え指示を入力してください",
            "description": "書き換えの指示を入力してください。例えば、「リスクに関する詳細を追加してください」と入力できます。"
        },
        "writeSocialMediaPost": {
            "title": "ソーシャルメディアに投稿する",
            "description": "再度書き直しを使用して、この言語を、重要なポイントを取り上げ、関与の領域を強調する、一般向けのソーシャル メディア投稿に再フォーマットします。"
        },
        "highlightPost": {
            "title": "生成された投稿をハイライトする",
            "description": "使用したい生成されたソーシャル メディアの投稿を強調表示します。"
        },
        "enterPostInstructions": {
            "title": "投稿手順を入力",
            "description": "投稿の指示を入力します。例えば、「LinkedIn向けに簡潔で魅力的な内容にしてください」などと入力できます。"
        },
        "complete": {
            "description": "お好みのソーシャルメディアプラットフォームを開き、投稿作成テキストボックスにフォーカスを当てて、生成された投稿を貼り付けてください。あるいは、準備が整うまで繰り返し修正を続けてください。"
        }
    },
    "inboxTriage": {
        "tourLabel": "音声とデバイス上のAIによる効率的なメール管理",
        "learn": "音声コマンドとインテリジェント タスクを使用して、データを安全に保ちながら受信トレイを効率的に管理する方法を学びます。",
        "tryOpen": {
            "title": "「Outlook を開く」または「Gmail を開く」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「Outlook を開く」または「Gmail を開く」と発声してください。選択したメールアプリが開きます。自動コントロール切り替えが有効になっている場合は、使用中のアプリに最適なアプリコントロールに切り替わります。"
        },
        "select": {
            "title": "メールアドレスを選択",
            "description": "メールをクリックします。次に、「メールを選択」と発声してみてください。これでフォーカスされたメールが選択されます。"
        },
        "delete": {
            "title": "メールを削除する",
            "description": "「削除」と言ってみてください。選択したメールが削除されます。"
        },
        "reply": {
            "title": "メールに返信する",
            "description": "メールをクリックします。次に、「返信」と発声してみましょう。すると、フォーカスされているメールの返信ウィンドウが開きます。"
        },
        "dictateIntro": {
            "title": "返信を音声入力する",
            "description": "ディクテーションを使えば、ハンズフリーで返信を入力できます。マイクがオンになっていて、ディクテーションモードが有効になっていることを確認してください。"
        },
        "dictateReply": {
            "title": "返信を開始する",
            "description": "「御社のサービスについてもっと詳しく知りたいと思っています。追加情報をお送りください。」と書いてみてください。こうすると、メールに返信内容が入力されます。返信テキストボックスに集中するようにしてください。"
        },
        "newEmail": {
            "title": "新しいメールを作成する",
            "description": "「新しいメール」と言ってみてください。新しいメール作成ウィンドウが開きます。"
        },
        "customEmailTemplates": {
            "title": "カスタムメールテンプレート",
            "description": "よくある返信用のカスタムメールテンプレートを作成できます。これにより、音声コマンドやクイックアクションを使って、事前に用意したコンテンツをメールに簡単に挿入できるようになります。"
        },
        "editAppControls": {
            "title": "アプリコントロールを編集する",
            "description": "カスタム電子メール テンプレートを作成するには、[アプリ コントロールの編集] ボタンをクリックします。"
        },
        "addNewControl": {
            "title": "新しいコントロールを追加",
            "description": "アプリ コントロール エディターで、[新しいコントロールの追加] ボタンをクリックします。"
        },
        "quickAction": {
            "title": "クイックアクションを選択",
            "description": "コントロール タイプとしてクイック アクションを選択します。"
        },
        "templateName": {
            "title": "テンプレートに名前を付ける",
            "description": "カスタム電子メール テンプレートに「会議出席依頼」などの名前を付けます。"
        },
        "eventType": {
            "title": "イベントの種類を選択",
            "description": "イベント タイプ セクションで、「type」のイベント タイプを選択します。"
        },
        "typeSteps": {
            "title": "タイプテンプレートコンテンツ",
            "description": "メールテンプレートの内容を入力します。例えば、「リードアウトリーチ\nこんにちは。今後のコラボレーションの可能性について話し合うために、ミーティングを予定したいと思っています。ご都合の良い日時をお知らせください。」のように入力できます。"
        },
        "finish": {
            "title": "テンプレートの作成を完了",
            "description": "[完了] ボタンをクリックして、カスタム電子メール テンプレートの作成を完了します。"
        },
        "saveTemplate": {
            "title": "テンプレートを保存する",
            "description": "「保存」ボタンをクリックして、カスタム電子メール テンプレートを保存します。"
        },
        "focusApp": {
            "title": "メールアプリに再び焦点を当てる",
            "description": "メール アプリに戻り、新しいメールの件名に注目していることを確認します。"
        },
        "useTemplate": {
            "title": "テンプレートを使用する",
            "description": "これで、カスタム メール テンプレートの名前を言うか、クイック アクション ボタンをクリックすることで、カスタム メール テンプレートを使用できるようになります。"
        },
        "generateIntro": {
            "title": "メールコンテンツを生成する",
            "description": "Cephable Intelligent Generateを使えば、メールアプリ内で直接メールコンテンツを作成することもできます。すべてデバイス上で行われるため、データのプライバシーとセキュリティは確保されます。"
        },
        "enterPrompt": {
            "title": "メールプロンプトを入力",
            "description": "プロンプト ボックスに次のように入力します: 潜在的な顧客に当社のサービスを紹介し、会議を依頼するプロフェッショナルなメールを書きます。"
        },
        "focusNewEmail": {
            "title": "新しいメールに注目",
            "description": "生成されたテキストを表示する新しい電子メール作成ウィンドウにフォーカスが当てられていることを確認します。"
        },
        "translateEmail": {
            "title": "メールの内容を翻訳する",
            "description": "Cephable Intelligent Translateを使えば、メールアプリ内でメールの内容を直接翻訳できます。すべてデバイス上で行われるため、データのプライバシーとセキュリティは確保されます。"
        },
        "highlightText": {
            "title": "メールの内容をハイライトする",
            "description": "翻訳したい長いメールの内容を強調表示します。"
        },
        "enterLanguage": {
            "title": "翻訳言語を入力",
            "description": "翻訳言語を入力してください。例えば、「スペイン語」と入力できます。"
        },
        "complete": {
            "description": "音声コマンドとインテリジェントタスクを使って、データのセキュリティを確保しながらメールの操作、返信、音声入力、メール作成、翻訳を行う方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、メール管理をさらにスムーズにしましょう。"
        }
    },
    "handsFreeMeeting": {
        "tourLabel": "ハンズフリーのクイック会議コントロール",
        "learn": "ハンズフリーの迅速な会議コントロールで時間を節約し、仮想会議の疲労を軽減します",
        "tryOpen": {
            "title": "「Zoom を開く」または「Teams を開く」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「Zoom を開く」または「Teams を開く」と発声してください。選択した会議アプリが開きます。自動コントロール切り替えが有効になっている場合は、使用しているアプリに最適なアプリコントロールに切り替わります。"
        },
        "mute": {
            "title": "マイクをミュートするには、「ミュートを切り替える」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「ミュートを切り替え」と発声してください。これにより、選択した会議アプリのマイクがミュートされます。"
        },
        "video": {
            "title": "カメラのオン/オフを切り替えるには、「ビデオをオン/オフにする」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「ビデオをオン」と言ってください。選択した会議アプリでカメラのオン/オフを切り替えることができます。"
        },
        "raiseHand": {
            "title": "「手を挙げて」と言って手を挙げてみましょう",
            "description": "マイクがオンになっていることを確認し、「手を挙げて」と言ってください。選択した会議アプリで手が挙がります。"
        },
        "quickType": {
            "title": "クイックタイピング",
            "description": "マイクがオンになっていることを確認し、「これは便利な機能です」と発声してください。こうすることで、ディクテーションモードを使わずに音声入力を素早く行うことができます。会議アプリのテキストフィールドにフォーカスを当てていることを確認してください。"
        },
        "complete": {
            "description": "音声コマンドとクイックアクションを使って、ミュート/ミュート解除、ビデオのオン/オフ、挙手、そしてお気に入りの会議アプリでのクイック入力を行う方法を習得しました。他のコマンドを試したり、独自のクイックアクションをカスタマイズして、会議をさらにスムーズにコントロールしてみましょう。"
        }
    },
    "summarizingReports": {
        "tourLabel": "オンデバイス AI でレポートやドキュメントを要約",
        "learn": "AI を活用した要約機能を使用して、機密データや独自データを安全に保ちながら、長いレポートやドキュメントから重要なポイントをすばやく取得する方法を学びます。",
        "summarizeIntro": {
            "title": "テキストを要約する",
            "description": "Cephableのインテリジェントタスクを使えば、長文のレポートや文書から要点を素早く抽出できます。SummarizeはオンデバイスAIタスクの一部で、インターネット接続なしでデバイスから実行できます。"
        },
        "navigateToReport": {
            "title": "レポートや文書に焦点を当てる",
            "description": "好みのアプリでレポートまたはドキュメントを開き、要約したいテキストにフォーカスを当てます。"
        },
        "highlightText": {
            "title": "要約するテキストを強調表示する",
            "description": "要約したいテキストを強調表示します。"
        },
        "copyText": {
            "title": "テキストをコピーする",
            "description": "テキストをハイライトした後、それをコピーして要約の準備をします。"
        },
        "enterPrompt": {
            "title": "要約の指示を入力してください",
            "description": "要約の指示を入力します。長さ、スタイル、または必要な具体的な内容を指定します。"
        },
        "pasteText": {
            "title": "レポートの内容を貼り付ける",
            "description": "指示に従って、コピーしたテキストを入力ボックスに貼り付けます。"
        },
        "focusChatApp": {
            "title": "チャットアプリに注力",
            "description": "Teams や Slack などのチャット アプリを開き、要約テキストを表示するテキスト ボックスにフォーカスを当てます。"
        },
        "rewriteIntro": {
            "title": "要約テキストの書き換え",
            "description": "Cephable Intelligent Rewrite を使えば、要約テキストをさらに洗練させることもできます。これらはすべてデバイス上で行われるため、データのプライバシーとセキュリティは確保されます。"
        },
        "highlightSummary": {
            "title": "要約テキストを強調表示する",
            "description": "さらに絞り込みたい要約テキストを強調表示します。"
        },
        "enterRewriteInstructions": {
            "title": "書き換え指示を入力してください",
            "description": "書き直しの指示を入力してください。トーン、スタイル、または具体的な変更点などを指定してください。"
        },
        "complete": {
            "description": "インテリジェントタスクを使って、迅速かつ安全にテキストを要約し、チームと調査結果を共有する方法を学びました。要約と書き換え、その他の機能を使って、ワークフローを最適化するユースケースをさらに探ってみましょう。"
        }
    },
    "congrats": "おめでとうございます！",
    "noteTakingAndDocumentation": {
        "tourLabel": "プライベートなデバイス内 AI を使用したメモ作成とドキュメント生成",
        "learn": "音声コマンド、スマート ディクテーション、AI タスクを使用して、メモからデザインやドキュメントを素早く作成する方法を学びます。",
        "focus": {
            "title": "テキストフィールドまたはドキュメントにフォーカスする",
            "description": "ディクテーションは、テキストフィールドまたはドキュメントにフォーカスを当てると最も効果的に機能します。メモを取りたいドキュメントを開くか、テキストフィールドをクリックしてください。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "さあ、話し始めましょう。アイデアを練りながら、自然に、考えを自由に表現してください。話した内容はすべて、フォーカスしたテキストフィールドまたはドキュメントに入力されます。コンセプトを説明したり、手順を大まかに説明したり、自由にブレインストーミングしたりしてみましょう。例えば、「チームの新しいワークフローを検討しています。まず、レポート作成プロセスを自動化し、その結果を毎週レビューするべきです」などと発言してください。カーソルがドキュメントにフォーカスされていることを確認してください。"
        },
        "typeEnter": {
            "title": "段落区切り",
            "description": "段落区切りを作成するには、キーボードのEnterキーを押すだけです。これにより、メモを明確なセクションに整理しやすくなります。考えを話し続けたり、他の人の話を書き写したりしてください。"
        },
        "rewriteIntro": {
            "title": "デザインを作成する",
            "description": "Cephable Intelligent Rewriteを使えば、メモを取り、機能のアイデアやフォローアップに反映させることができます。すべてデバイス上で行われるため、データのプライバシーとセキュリティは確保されます。"
        },
        "highlightText": {
            "title": "ノートを強調表示する",
            "description": "デザインやドキュメントの作成に使用するすべてのメモを選択します。"
        },
        "inPlaceReplacement": {
            "title": "現場でのアイデア創出",
            "description": "それでは、インプレース置換を使ってメモをデザインやドキュメントに変換してみましょう。貼り付けモードやオプションを使って新しいファイルを作成することもできます。"
        },
        "enterInstructions": {
            "title": "設計指示を入力",
            "description": "メモには、次に何をしたいかという指示を書き込むことができます。フォーマット、デザイン、フォローアップタスクなど、何でも構いません。（例：機能の動作方法、エンドツーエンドの概要、成功の見通しをまとめた設計ドキュメントを作成するなど。）"
        },
        "complete": {
            "description": "音声コマンドとスマートディクテーションを使って臨床ノートを作成し、インテリジェントリライトを使ってSOAPスタイルでフォーマットする方法を学びました。ディクテーションとリライト、あるいはワークフローを最適化するその他の機能を使ったユースケースをさらに探ってみましょう。"
        }
    },
    "fpsGamePlay": {
        "tourLabel": "音声コントロールでFPSゲームをプレイ",
        "learn": "音声コントロールとクイックアクションを使用して FPS ゲームをプレイする方法を学びます。",
        "changeProfile": {
            "title": "変更管理プロファイル",
            "description": "アプリのコントロールをFPSゲームプロファイルに変更してください。プレイしたいゲームに合わせてカスタマイズすることもできます。動画をご覧ください。"
        },
        "autoProfileSwitching": {
            "title": "自動制御切り替えをオフにする",
            "description": "これにより、アプリを変更するまで現在のアプリのコントロールがアクティブなままになります。"
        },
        "tryOpen": {
            "title": "「Valorantを開く」または「Battlefieldを開く」と言ってみてください"
        },
        "go": {
            "title": "「Go」と言ってみてください",
            "description": "マイクがオンになっていることを確認して、「Go」と言ってください。キャラクターが前進し始めます。"
        },
        "stop": {
            "title": "「ストップ」と言ってみてください",
            "description": "マイクがオンになっていることを確認して、「停止」と言ってください。これでキャラクターの動きが止まります。"
        },
        "complete": {
            "description": "FPSゲームで音声コマンドとクイックアクションを使ってキャラクターを動かしたり、停止したり、操作する方法を習得しました。もっと多くのコマンドを試したり、クイックアクションをカスタマイズして、よりスムーズでスピーディーなゲームプレイを実現しましょう。"
        }
    },
    "presentationControls": {
        "tourLabel": "音声コマンドでプレゼンテーションを制御する",
        "learn": "音声コマンドとクイックアクションを使用して、ハンズフリーでプレゼンテーションを操作および制御する方法を学びます。",
        "tryOpen": {
            "title": "「PowerPoint を開く」または「Google スライドを開く」と言ってみてください。"
        },
        "startPresentation": {
            "title": "スライドショーを開始するには、「プレゼンテーションを開始」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「プレゼンテーションを開始」と言ってください。選択したプレゼンテーションアプリでスライドショーが開始されます。"
        },
        "nextSlide": {
            "title": "次のスライドに移動するには、「次のスライド」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「次のスライド」と言ってください。スライドショーの次のスライドに進みます。"
        },
        "previousSlide": {
            "title": "前のスライドに戻るには、「前のスライド」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「前のスライド」と言ってください。スライドショーの前のスライドに戻ります。"
        },
        "escape": {
            "title": "プレゼンテーションモードを終了するには、「Escape」と発声してみてください",
            "description": "マイクがオンになっていることを確認し、「Escape」と発声してください。これにより、選択したプレゼンテーションアプリのプレゼンテーションモードが終了します。"
        },
        "complete": {
            "description": "音声コマンドとクイックアクションを使って、ハンズフリーでプレゼンテーションを開始、操作、終了する方法を習得しました。他のコマンドを試したり、独自のクイックアクションをカスタマイズして、プレゼンテーションをさらにスムーズに操作してみましょう。"
        }
    },
    "editingImages": {
        "tourLabel": "音声コントロールとディクテーションによるより高速な画像編集",
        "learn": "音声コマンド、クイックアクション、ディクテーションを使用して画像編集プロセスを改善する方法を学びます。",
        "tryOpen": {
            "title": "「Figmaを開く」または「Photoshopを開く」と言ってみてください。"
        },
        "selectAll": {
            "title": "キャンバス上のすべての要素を選択するには、「すべて選択」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「すべて選択」と言ってください。選択した画像編集アプリのキャンバス上のすべての要素が選択されます。アプリにフォーカスしていることを確認してください。"
        },
        "bold": {
            "title": "選択したテキストを太字にするには、「太字」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「太字」と発声してください。選択した画像編集アプリで選択したテキストが太字になります。テキストが選択されていることを確認してください。"
        },
        "copy": {
            "title": "選択した要素をコピーするには、「コピー」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「コピー」と言ってください。選択した画像編集アプリで選択した要素がコピーされます。要素が選択されていることを確認してください。"
        },
        "paste": {
            "title": "コピーした要素を貼り付けるには、「貼り付け」と言ってみてください。",
            "description": "マイクがオンになっていることを確認し、「貼り付け」と言ってください。コピーした要素が選択した画像編集アプリに貼り付けられます。"
        },
        "delete": {
            "title": "選択した要素を削除するには、「Delete」と言ってみてください",
            "description": "マイクがオンになっていることを確認し、「削除」と発声してください。選択した画像編集アプリで選択した要素が削除されます。要素が選択されていることを確認してください。"
        },
        "dictationIntro": {
            "title": "ディクテーション",
            "description": "ディクテーションを使用すると、音声でテキストを入力できます。マイクがオンになっていて、ディクテーションモードが有効になっていることを確認してください。"
        },
        "focus": {
            "title": "テキストフィールドにフォーカスする",
            "description": "画像編集アプリで、ディクテーションを使用するテキスト フィールドをクリックします。"
        },
        "speaking": {
            "title": "話し始める",
            "description": "「早期割引コードはQRコードをスキャンしてください。9月30日まで有効です。その後、ウェブサイトからお申し込みください。」と発声してみましょう。音声入力したいテキストフィールドまたは領域に焦点を合わせていることを確認してください。"
        },
        "complete": {
            "description": "音声コマンド、クイックアクション、ディクテーションを使って画像編集プロセスを改善する方法を習得しました。他のコマンドを試したり、クイックアクションをカスタマイズして、画像編集をさらにスムーズにしましょう。"
        }
    },
    "redo": "オンボーディングをやり直す",
    "title": "Cephableについて",
    "description": "あなたのパーソナル AI アシスタントである Cephable を体験し、パーソナライズされたユースケースへの関心を共有しましょう。",
    "panel": {
        "description": "これはメインのコントロールセンターとなるパネルです。常に表示されており、音声を使ってアプリなどを操作できます。まずはマイクから始めましょう。"
    }
}
